import { BoxV2 as Box, Button, Flex } from 'portal-commons';
import { FunctionComponent } from 'react';

import { Modal } from '@/components';

interface ChannelChangeModalProps {
  open?: boolean;
  onCancel?: () => void;
  onSubmit?: () => void;
}

const Title: FunctionComponent = ({ children }) => (
  <Box
    sx={{
      paddingTop: 's',
      paddingBottom: 's',
      color: 't.black80',
      fontWeight: 600,
      fontSize: 'H600',
      lineHeight: 'normal',
    }}
  >
    {children}
  </Box>
);

const Message: FunctionComponent = ({ children }) => (
  <Box
    sx={{
      paddingBottom: 'xs',
      color: 't.black80',
      fontWeight: 400,
      fontSize: 'H400',
      lineHeight: 'normal',
    }}
  >
    {children}
  </Box>
);

const Actions: FunctionComponent = ({ children }) => (
  <Flex
    sx={{
      flexDirection: 'row',
      alignItems: 'center',
      gap: '18px',
      padding: '30px 0',
    }}
  >
    {children}
  </Flex>
);

const ChannelChangeModal: FunctionComponent<ChannelChangeModalProps> = ({
  open = false,
  onCancel,
  onSubmit,
}) => (
  <Modal open={open}>
    <Title>Channel Selection</Title>
    <Message>
      You are about to change channels, this will reset all selections past this
      point. Click <span style={{ fontWeight: 800 }}>Confirm</span> to continue.
    </Message>
    <Actions>
      <Button variant="outline" onClick={onCancel}>
        Cancel
      </Button>
      <Button onClick={onSubmit}>Confirm</Button>
    </Actions>
  </Modal>
);

export default ChannelChangeModal;
